export default {
  install(Vue) {
    Vue.prototype.$reachGoal = function (goal, params = {}) {
      if (window.ym) {
        window.ym(98835523, "reachGoal", goal, params);
        console.log(goal);
      } else {
        console.warn("Яндекс.Метрика не инициализирована");
      }
    };
  },
};
